import React from 'react'
import { Link } from 'react-router-dom'
import { useCartStore } from '~/src/features/cart/stores/useCartStore'

export function CartPage() {
  const cart = useCartStore((state) => state.cart)
  const error = useCartStore((state) => state.error)
  const updateItem = useCartStore((state) => state.updateItem)

  return (
    <div className="shop-section narrow">
      <h1>Carrito</h1>
      {error && <p className="shop-error">{error}</p>}
      {cart.items.length === 0 ? <p>No hay productos agregados.</p> : null}
      {cart.items.map((item) => (
        <div key={item.id} className="cart-row">
          <div className="cart-row__product">
            <div className="cart-row__image">
              {item.product.image_path ? <img src={item.product.image_path} alt={item.product.name} /> : <span>Sin imagen</span>}
            </div>
            <div>
              <strong>{item.product.name}</strong>
              <p>{item.product.maker}</p>
            </div>
          </div>
          <div className="cart-row__actions">
            <button
              onClick={() => updateItem(item.id, item.quantity - 1)}
            >
              -
            </button>
            <span>{item.quantity}</span>
            <button
              onClick={() => updateItem(item.id, item.quantity + 1)}
            >
              +
            </button>
          </div>
          <strong>${item.total_price.toFixed(2)}</strong>
        </div>
      ))}
      <div className="cart-summary">
        <span>Subtotal</span>
        <strong>${(cart.subtotal_amount || 0).toFixed(2)}</strong>
      </div>
      <div className="cart-checkout">
        <Link className="shop-button" to="/checkout">
          Realizar orden de compra
        </Link>
      </div>
    </div>
  )
}
